import React, { useEffect } from 'react';
import { useTranslation, useUpdateStore, isPlaceholderVersion } from '../store';

const Version = () => {
  const { t } = useTranslation();
  const localVersionInfo = useUpdateStore((state) => state.localVersionInfo);
  const loadLocalVersion = useUpdateStore((state) => state.loadLocalVersion);

  useEffect(() => {
    loadLocalVersion();
  }, [loadLocalVersion]);

  if (!localVersionInfo) return <div>{t('loadingVersion')}</div>;

  const version = isPlaceholderVersion(localVersionInfo.version) ? t('na') : localVersionInfo.version;
  const buildDate = !localVersionInfo.buildDate || localVersionInfo.buildDate === '{{BUILD_DATE}}'
    ? t('na')
    : new Date(localVersionInfo.buildDate).toLocaleString();

  return (
    <div style={{ padding: '8px', fontSize: '12px', color: '#666' }}>
      {t('version')} {version} | {t('built')} {buildDate}
    </div>
  );
};

export default Version;